import React, { useEffect, useState } from 'react';
import MajorDetailBtm from '../components/MajorDetailBtm';
import { Major, Path } from '../../lib/types';
import { getPath } from '../../lib/api';
import { useAlumniArrStore } from '../../state/alumniArrStore';
import { toast } from 'sonner';
import PublicError from '../components/PublicError';

function PathsContentComponent({
  paths,
  group,
  selectedLevel,
  setSelectedLevel,
}: {
  paths: Path[];
  group: Major[] | undefined;
  selectedLevel: string;
  setSelectedLevel: React.Dispatch<React.SetStateAction<string>>;
}) {
  const [selectedPathId, setSelectedPathId] = useState<number>(paths[0].id);
  const [selectedPath, setSelectedPath] = useState<Path | null>();
  const { alumniArr, setAlumniArr } = useAlumniArrStore();

  function handleChange(pathId: string) {
    setSelectedPathId(parseInt(pathId));
  }

  useEffect(() => {
    async function fetch_setPath() {
      try {
        const result = await getPath(selectedPathId);
        if (result.status !== 200) {
          toast.error('Uh oh❗ Something went wrong.', {
            description:
              'There was a problem loading fetching the selected path details.',
            cancel: {
              label: 'Cancel',
            },
          });
          return;
        }
        setSelectedPath(result.data);
      } catch (error: any) {
        toast.error('Uh oh❗ There was a problem fetching major.', {
          description: error.response.data,
          cancel: {
            label: 'Cancel',
          },
        });
      }
    }
    fetch_setPath();
  }, [selectedPathId]);

  useEffect(() => {
    if (selectedPathId === 0) {
      return;
    }

    setAlumniArr(selectedPath?.alumniSet || []);
  }, [selectedPath, selectedPathId]);

  return (
    <>
      {paths?.length === 0 ? (
        <PublicError
          title="There does not seem to be anything here 👀"
          description="No published paths found for this major!"
        />
      ) : (
        <>
          {selectedPath !== null && (
            <MajorDetailBtm
              paths={paths}
              selectedPath={selectedPath}
              selectedPathId={selectedPathId}
              selectedLevel={selectedLevel}
              setSelectedLevel={setSelectedLevel}
              contentArr={selectedPath?.publishContentSet}
              handleChange={handleChange}
              alumniSet={alumniArr}
            />
          )}
        </>
      )}
    </>
  );
}

export default PathsContentComponent;
